import useRequests from "./useRequests";
import { useLocalStorage } from "./useLocalStorage";
import axios from "axios";
import { useEffect, useState } from "react";
import moment from "jalali-moment";

const useFunctions = () => {
  const http = useRequests();
  const [user] = useLocalStorage("user", null);
  const [bla, setBla] = useState(null);
  const getUserList = async () => {
    try {
      const res = await http.get("api/users?nameId=true");
      console.log("user list in useFunction; ", res);
      return res?.data;
    } catch (error) {
      console.log(error);
    }
  };

  const getLoggedInMember = async () => {
    try {
      console.log("getLoggedInMember, ", user?.user?.id);
      const res = await http.get("api/users/" + user?.user?.id);
      console.log("member list in useFunction; ", res);
      return res?.data;
    } catch (error) {
      console.log(error);
    }
  };

  const getBla = async () => {
    try {
      console.log(bla);
      setBla(null);
      axios.get("https://professordriving.com/bla.php").then(res => {
        console.log("test log: ", res);
        setBla(res?.data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getBla();
  }, []);

  return { getUserList, getLoggedInMember, bla, getBla };
};

export default useFunctions;
